import { io, Socket } from 'socket.io-client';
import { socketEvents } from '../../interfaces/socket.interface';
import { api } from '../api';
import store from '../store';
import { enqueueSnackbar } from 'notistack';

// const reloginRequest = () => store.dispatch(api.endpoints.relogin.initiate());

class SocketService {
  private socket: Socket | null = null;

  /**
   * Connects to the socket server.
   */
  public connect(serverUrl: string): void {
    this.socket = io(serverUrl, {
      path: '/api/socket.io',
      transports: ['websocket'],
      withCredentials: true
    });

    this.socket.on(socketEvents.CONNECT, () => {
      console.log('Connected to socket server');
    });
    this.socket.on(socketEvents.DISCONNECT, () => {
      console.log('Disconnected from socket server');
    });

    this.socket.on(socketEvents.ERROR, (error: Error) => {
      console.error('Socket error:', error);
    });

    this.setupListeners();
  }

  /**
   * Set up all the socket event listeners here.
   */
  private setupListeners(): void {
    if (!this.socket) {
      return;
    }

    this.socket.on(socketEvents.RELOGIN, async (message) => {
      await store
        .dispatch(api.endpoints.relogin.initiate())
        .refetch()
        .then(() => enqueueSnackbar<'info'>(message));
    });
  }

  /**
   * Disconnects from the socket server.
   */
  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      console.log('Disconnected from socket server');
    }
  }

  /**
   * Sends a message to the server.
   */
  public sendMessage(event: string, data: unknown): void {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  /**
   * Handle event registration dynamically.
   */
  public onEvent(event: string, callback: (data: unknown) => void): void {
    this.socket?.on(event, callback);
  }
}

const socketService = new SocketService();
export default socketService;
